// extracted by mini-css-extract-plugin
export default {"workcellOverview":"workcellOverview-n91lr"};